'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginCtrl',
        params: {
          redirect: null,
          stateParams: {}
        }
      });
  });